import templateUrl from "emun.products/configurator/product-configurator-prompt.htm";
import basicController from "servicestack/basic.controller.properties";
import config from "emun.products/configurator/product-configurator.config";
import cartItemQuickViewPrompt from "emun.cart/cart-item-quick-view-prompt";
import Product from "emun.shopping/product.model";
import open from "webmodals/open";
import actionList from "webmodals/action-list";
import resolve from "ioc/resolve";

export { config };

export default (
  {
    size = "md configurator",
    backdrop = false,
    product = {
      qtyToAdd: 1,
      options: [],
      id: "N/A",
      shortDescription: "Oops!!!",
    },
    cartItem = {},
    $parent = {},
    values = product.options || [],
    layout = "compact", // compact|slider
    placement = "center",
    okButtonText = "Add",
    preventAutoHeight = true,
    add = true,
    title = `${product.shortDescription}`,
    subTitle = product.id,
  },
  optionGroupList
) => {
  const $cart = resolve("$cart");
  console.debug("openConfigurator", {
    size,
    backdrop,
    $cart,
    templateUrl,
    placement,
    preventAutoHeight,
    product,
    values,
    add,
    title,
    subTitle,
    layout,
    okButtonText,
    optionGroupList,
  });
  const launch = ($product = product, asShownValues) =>
    open({
      size,
      backdrop,
      templateUrl,
      placement,
      controller() {
        const $ctrl = this;
        // console.debug(templateUrl, {
        //   values,
        //   product,
        //   cartItem,
        //   $ctrl,
        //   $product,
        //   asShownValues,
        // });
        basicController($ctrl);
        Object.assign($ctrl, {
          preventAutoHeight,
          product: $product,
          values: asShownValues || values,
          add,
          title,
          subTitle,
          layout,
          okButtonText,
          optionGroupList,
        });
        $ctrl.submit = () => {
          const item = {
            ...cartItem,
            qtyPurchased: $ctrl.quantity,
            options: $ctrl.configurator.options,
            optionGroupList: $ctrl.configurator.optionGroupList,
          };

          if (!$ctrl.configurator.isValid()) {
            $ctrl.$modals.alert($ctrl.configurator.errors.join("\n"));
            return console.warn("fix configurator errors", $ctrl.configurator);
          }
          const call =
            item.position > 0
              ? $ctrl.$cart.changeOptions(item)
              : $ctrl.$cart.addItem(item, $product, false);

          call.then((res) => $ctrl.$close(res));
          $ctrl.$close({
            ...$ctrl.configurator,
            $product,
            configurator: $ctrl.configurator,
          });
        };
      },
      bindToController: true,
      controllerAs: "$ctrl",
    }).result;

  if (!cartItem.position && product.isAsShown) {
    return actionList({
      size,
      backdrop,
      placement,
      title: "Customize Product",
      // subTitle: `How would you like to proceed?`,
      actions: {
        "Add to Bag": {
          // icon: "wrench",
          body: `Add item as shown to your bag`,
          buttonLabel: "Add",
          handler: () => {
            console.debug("add as shown", { product, cartItem });
            const item = {
              ...cartItem,
              cartId: $cart.id,
              product,
              productId: product.id,
              options: product.asShownValues,
              values: product.asShownValues,
              // quantity: this.product.qtyToAdd,
            };
            $cart.addItem(item, product, true);
            //launch(product, product.asShownValues);
          },
        },
        // "Edit From Display": {
        //   // icon: "wrench",
        //   body: `Edit this product starting with the fabrics shown in the display image`,
        //   buttonLabel: "Edit",
        //   handler: () => launch(product, product.asShownValues),
        // },
        "Start From Scratch": {
          // icon: "magic",
          body: `Customize this product from scratch with up to 400+ options on fabrics, finishes and nailheads`,
          buttonLabel: "Customize",
          handler() {
            // close
            $parent && $parent.$dismiss && $parent.$dismiss();
            return Product.get(product.manufacturerNumber).then((op) => {
              console.debug("original product", op);
              const p = new Product(op);
              cartItemQuickViewPrompt({
                cartItem: { ...cartItem, product: p, values: [] },
                product: p,
              }); //.then(() => load());
              return launch(p, []);
            });
          },
        },
      },
    }).then((a) => a.handler());
  } else {
    return launch();
  }
};
